module.exports = __webpack_public_path__ + "/build/web/images/exclusive-collection@2x.4cb8cdfab5a02121ef61344da211600c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/exclusive-collection@2x.jpg
// module id = 128
// module chunks = 13